var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquares(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1109,
    height: 174,
    viewBox: "0 0 1109 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1107.91,
    y: 104.735,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 1107.91 104.735)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1094.05,
    y: 118.593,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 1094.05 118.593)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1079.09,
    y: 132.452,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 1079.09 132.452)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 553.56,
    y: 104.735,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 553.56 104.735)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 539.701,
    y: 118.593,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 539.701 118.593)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 524.733,
    y: 132.452,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 524.733 132.452)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1038.62,
    y: 70.0879,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 1038.62 70.0879)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1024.76,
    y: 83.9465,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 1024.76 83.9465)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1009.79,
    y: 97.8054,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 1009.79 97.8054)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 484.266,
    y: 70.0876,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 484.266 70.0876)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 470.407,
    y: 83.9463,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 470.407 83.9463)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 455.44,
    y: 97.8052,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 455.44 97.8052)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 969.325,
    y: 104.735,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 969.325 104.735)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 955.466,
    y: 118.593,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 955.466 118.593)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 940.499,
    y: 132.453,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 940.499 132.453)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 414.972,
    y: 104.735,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 414.972 104.735)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 401.113,
    y: 118.593,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 401.113 118.593)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 386.146,
    y: 132.453,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 386.146 132.453)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 900.03,
    y: 70.0874,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 900.03 70.0874)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 886.171,
    y: 83.9458,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 886.171 83.9458)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 871.204,
    y: 97.8049,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 871.204 97.8049)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 345.677,
    y: 70.0874,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 345.677 70.0874)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 331.818,
    y: 83.9458,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 331.818 83.9458)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 316.851,
    y: 97.8047,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 316.851 97.8047)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 830.736,
    y: 104.735,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 830.736 104.735)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 816.877,
    y: 118.593,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 816.877 118.593)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 801.911,
    y: 132.453,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 801.911 132.453)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 276.384,
    y: 104.735,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 276.384 104.735)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 262.525,
    y: 118.593,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 262.525 118.593)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 247.557,
    y: 132.452,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 247.557 132.452)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 761.442,
    y: 70.0879,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 761.442 70.0879)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 747.583,
    y: 83.946,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 747.583 83.946)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 732.616,
    y: 97.8052,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 732.616 97.8052)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 207.09,
    y: 70.0874,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 207.09 70.0874)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 193.231,
    y: 83.9458,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 193.231 83.9458)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 178.263,
    y: 97.8049,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 178.263 97.8049)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 692.148,
    y: 104.735,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 692.148 104.735)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 678.289,
    y: 118.593,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 678.289 118.593)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 663.322,
    y: 132.452,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 663.322 132.452)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 137.795,
    y: 104.735,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 137.795 104.735)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 123.936,
    y: 118.593,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 123.936 118.593)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 108.969,
    y: 132.452,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 108.969 132.452)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 622.854,
    y: 70.0879,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 622.854 70.0879)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 608.995,
    y: 83.9463,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 608.995 83.9463)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 594.027,
    y: 97.8054,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 594.027 97.8054)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 68.501,
    y: 70.0874,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 68.501 70.0874)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6426,
    y: 83.9463,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 54.6426 83.9463)",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 39.6748,
    y: 97.8052,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 39.6748 97.8052)",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1107.91,
    y: 35.4404,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 1107.91 35.4404)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 1094.05,
    y: 49.2993,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 1094.05 49.2993)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 1079.09,
    y: 63.1582,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 1079.09 63.1582)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 553.56,
    y: 35.4407,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 553.56 35.4407)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 539.701,
    y: 49.2995,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 539.701 49.2995)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 524.734,
    y: 63.1584,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 524.734 63.1584)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 1038.62,
    y: 0.793444,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 1038.62 0.793444)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1024.76,
    y: 14.6521,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 1024.76 14.6521)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 1009.79,
    y: 28.5112,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 1009.79 28.5112)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 484.265,
    y: 0.793444,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 484.265 0.793444)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 470.406,
    y: 14.6518,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 470.406 14.6518)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 455.439,
    y: 28.5107,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 455.439 28.5107)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 969.325,
    y: 35.4404,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 969.325 35.4404)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 955.466,
    y: 49.2993,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 955.466 49.2993)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 940.499,
    y: 63.1579,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 940.499 63.1579)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 414.972,
    y: 35.4402,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 414.972 35.4402)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 401.113,
    y: 49.2988,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 401.113 49.2988)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 386.146,
    y: 63.1579,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 386.146 63.1579)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 900.031,
    y: 0.793444,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 900.031 0.793444)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 886.172,
    y: 14.6518,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 886.172 14.6518)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 871.205,
    y: 28.511,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 871.205 28.511)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 345.678,
    y: 0.793444,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 345.678 0.793444)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 331.819,
    y: 14.6521,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 331.819 14.6521)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 316.852,
    y: 28.5112,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 316.852 28.5112)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 830.736,
    y: 35.4404,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 830.736 35.4404)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 816.877,
    y: 49.2993,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 816.877 49.2993)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 801.911,
    y: 63.1579,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 801.911 63.1579)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 276.384,
    y: 35.4402,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 276.384 35.4402)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 262.525,
    y: 49.2988,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 262.525 49.2988)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 247.558,
    y: 63.1577,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 247.558 63.1577)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 761.442,
    y: 0.793444,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 761.442 0.793444)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 747.583,
    y: 14.6521,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 747.583 14.6521)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 732.615,
    y: 28.5112,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 732.615 28.5112)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 207.09,
    y: 0.793444,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 207.09 0.793444)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 193.23,
    y: 14.6521,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 193.23 14.6521)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 178.263,
    y: 28.511,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 178.263 28.511)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 692.148,
    y: 35.4404,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 692.148 35.4404)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 678.289,
    y: 49.2993,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 678.289 49.2993)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 663.322,
    y: 63.1579,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 663.322 63.1579)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 137.795,
    y: 35.4404,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 137.795 35.4404)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 123.936,
    y: 49.2991,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 123.936 49.2991)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 108.969,
    y: 63.1579,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 108.969 63.1579)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 622.854,
    y: 0.793444,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 622.854 0.793444)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 608.995,
    y: 14.6523,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 608.995 14.6523)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 594.027,
    y: 28.511,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 594.027 28.511)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 68.501,
    y: 0.793444,
    width: 67.7072,
    height: 67.7072,
    transform: "rotate(90 68.501 0.793444)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6426,
    y: 14.6521,
    width: 39.9896,
    height: 39.9896,
    transform: "rotate(90 54.6426 14.6521)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 39.6748,
    y: 28.511,
    width: 12.2719,
    height: 12.2719,
    transform: "rotate(90 39.6748 28.511)",
    fill: "black",
    stroke: "#FDF8F5",
    strokeWidth: 1.58689
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares);
export default __webpack_public_path__ + "static/media/squares.1fd26b58a41b766baac5b097eddc0948.svg";
export { ForwardRef as ReactComponent };